import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  role: "list",
  class: "mt-2 space-y-2 text-sm"
}
const _hoisted_2 = {
  key: 0,
  class: "text-gray-600"
}
const _hoisted_3 = { class: "text-brand-main pr-2" }
const _hoisted_4 = {
  key: 0,
  href: "/diamanten/gia_zertifikat",
  target: "_blank",
  class: "text-black underline"
}
const _hoisted_5 = {
  key: 1,
  href: "/diamanten/im_labor_hergestellte_diamanten#facts",
  target: "_blank",
  class: "text-black underline"
}



const pageStr = "components.description.descriptionPartsSub"

export default /*@__PURE__*/_defineComponent({
  __name: 'descriptionPartsSub',
  props: ["subList"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_description_parts_sub = _resolveComponent("description-parts-sub", true)!

  return (__props.subList != 'undefined')
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subList, (subDetail, subDetailIdx) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "text-black text-sm",
            key: subDetailIdx
          }, [
            (subDetail.title !== '' && subDetail.value != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(subDetail.title) + ":", 1),
                  (subDetail.parameter == 'stone_certificate')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (subDetail.value.includes('GIA'))
                          ? (_openBlock(), _createElementBlock("a", _hoisted_4, _toDisplayString(_ctx.$t(pageStr + '.gemological_certificate')), 1))
                          : (subDetail.value.includes('IGI'))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_5, _toDisplayString(_ctx.$t(pageStr + '.gemological_certificate')), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(subDetail.value), 1)
                              ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(subDetail.value), 1)
                      ], 64))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_description_parts_sub, {
              "sub-list": subDetail.sub
            }, null, 8, ["sub-list"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})